import React from 'react'

export default function SingleTestimonial(props) {
    return (
        <div className="col-md col-sm-8 col-11 mx-md-0 mx-auto pb-2 single-testimonial">
            <p className='text-center m-0'>
                "{props.testText}"
            </p>
            <div className="testimonial-author mt-3 d-flex justify-content-center align-items-center gap-3">
                <img src={props.testAuthorImg} alt="testimonial-author" />
                <p className='m-0 p-0'>{props.testAuthorName}</p>
            </div>
        </div>
    )
}
